<div class="create-location-form">
  <h4 class="form-title">{{ 'companies_selection_dialog.new_shipping_location_title' | translate }}</h4>

  <div class="form-field">
    <label class="field-label muted">{{ 'companies_selection_dialog.parent_company' | translate }}</label>
    <div class="company-select">
      <div class="company-select-trigger" (click)="toggleCompanyPicker()" [class.open]="showCompanyPicker">
        <span class="company-chip" *ngIf="parentCompany">
          <ui-svg-icon svgIcon="shop" size="small"></ui-svg-icon>
          <span class="company-chip-name">{{ parentCompany.name }}</span>
          <ui-svg-icon class="chip-clear" svgIcon="close" size="small" (click)="clearCompany($event)"></ui-svg-icon>
        </span>
        <span class="company-placeholder" *ngIf="!parentCompany">
          {{ 'companies_selection_dialog.parent_company_placeholder' | translate }}
        </span>
        <ui-svg-icon class="dropdown-caret" svgIcon="chevron_down" size="small"></ui-svg-icon>
      </div>

      <div class="company-panel" *ngIf="showCompanyPicker">
        <div class="company-panel-search">
          <ui-form-field [ngModel]="companySearchTerm" (ngModelChange)="onCompanySearch($event)"
            [placeholder]="'companies_selection_dialog.parent_company_placeholder' | translate"
            type="text" suffixIcon="search">
          </ui-form-field>
        </div>
        <div class="company-panel-list" (scroll)="onCompanyScroll($event)">
          <div class="loading-more" *ngIf="isLoadingCompanies">
            <ui-svg-icon svgIcon="eclipse"></ui-svg-icon>
          </div>
          <ng-container *ngIf="!isLoadingCompanies">
            <button type="button" class="company-option"
              *ngFor="let company of companies"
              [class.selected]="company.id === parentCompany?.id"
              (click)="selectCompany(company)">
              <ui-svg-icon svgIcon="shop" size="small"></ui-svg-icon>
              <span>{{ company.name }}</span>
            </button>
            <div class="loading-more" *ngIf="isLoadingMoreCompanies">
              <ui-svg-icon svgIcon="eclipse"></ui-svg-icon>
            </div>
            <div class="picker-no-data" *ngIf="companies.length === 0">
              {{ 'companies_selection_dialog.no_data' | translate }}
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>

  <div class="form-field">
    <label class="field-label">{{ 'companies_selection_dialog.location_name' | translate }}</label>
    <ui-form-field [(ngModel)]="locationName" type="text"
      [placeholder]="'companies_selection_dialog.location_name' | translate">
    </ui-form-field>
  </div>

  <div class="form-field">
    <label class="field-label">{{ 'companies_selection_dialog.location_address' | translate }}</label>
    <div class="address-search-row">
      <ui-form-field #addressField id="apartment" [(ngModel)]="apartment" type="text"
        (focus)="addressAutoComplete()"
        [placeholder]="'companies_selection_dialog.location_address' | translate">
      </ui-form-field>
      <ui-button type="secondary" icon="search" iconSize="medium"
        [attr.title]="(isSearching ? 'companies_selection_dialog.searching' : 'companies_selection_dialog.search') | translate"
        [isLoading]="isSearching" [disabled]="!apartment.trim() || isSearching"
        (click)="searchAddress()">
      </ui-button>
    </div>
    <span class="field-error" *ngIf="searchError">
      {{ 'companies_selection_dialog.search_failed' | translate }}
    </span>
    <!-- Dev-only: no real Google Maps API key configured locally. Disappears
         on its own once index.html has a working key. -->
    <button type="button" class="dev-simulate-autocomplete" *ngIf="!googlePlacesAvailable"
      (click)="simulateAddressAutoComplete()">
      {{ 'companies_selection_dialog.simulate_google_places' | translate }}
    </button>
  </div>

  <div class="structured-address-row">
    <div class="form-field">
      <label class="field-label muted">{{ 'companies_selection_dialog.location_street' | translate }}</label>
      <ui-form-field [(ngModel)]="street" type="text"
        [placeholder]="'companies_selection_dialog.location_street' | translate">
      </ui-form-field>
    </div>
    <div class="form-field">
      <label class="field-label muted">{{ 'companies_selection_dialog.location_city' | translate }}</label>
      <ui-form-field [(ngModel)]="city" type="text"
        [placeholder]="'companies_selection_dialog.location_city' | translate">
      </ui-form-field>
    </div>
    <div class="form-field">
      <label class="field-label muted">{{ 'companies_selection_dialog.location_zip' | translate }}</label>
      <ui-form-field [(ngModel)]="zip" type="text"
        [placeholder]="'companies_selection_dialog.location_zip' | translate">
      </ui-form-field>
    </div>
  </div>

  <div class="structured-address-row">
    <div class="form-field">
      <label class="field-label muted">{{ 'companies_selection_dialog.location_country' | translate }}</label>
      <div class="country-select">
        <div class="company-select-trigger" (click)="toggleCountryPicker()" [class.open]="showCountryPicker">
          <span class="company-chip" *ngIf="selectedCountry">
            <span class="company-chip-name">{{ selectedCountry.name }}</span>
            <ui-svg-icon class="chip-clear" svgIcon="close" size="small" (click)="clearCountry($event)"></ui-svg-icon>
          </span>
          <span class="company-placeholder" *ngIf="!selectedCountry">
            {{ 'companies_selection_dialog.location_country' | translate }}
          </span>
          <ui-svg-icon class="dropdown-caret" svgIcon="chevron_down" size="small"></ui-svg-icon>
        </div>

        <div class="company-panel" *ngIf="showCountryPicker">
          <div class="company-panel-search">
            <ui-form-field [ngModel]="countrySearchTerm" (ngModelChange)="onCountrySearch($event)"
              [placeholder]="'companies_selection_dialog.location_country' | translate"
              type="text" suffixIcon="search">
            </ui-form-field>
          </div>
          <div class="company-panel-list">
            <div class="loading-more" *ngIf="isLoadingCountries">
              <ui-svg-icon svgIcon="eclipse"></ui-svg-icon>
            </div>
            <ng-container *ngIf="!isLoadingCountries">
              <button type="button" class="company-option"
                *ngFor="let countryOption of countryOptions"
                [class.selected]="countryOption.id === selectedCountry?.id"
                (click)="selectCountry(countryOption)">
                <span>{{ countryOption.name }}</span>
              </button>
              <div class="picker-no-data" *ngIf="countryOptions.length === 0">
                {{ 'companies_selection_dialog.no_data' | translate }}
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>

    <div class="form-field">
      <label class="field-label muted">{{ 'companies_selection_dialog.location_province' | translate }}</label>
      <div class="province-select" [class.disabled]="!selectedCountry">
        <div class="company-select-trigger" (click)="toggleProvincePicker()" [class.open]="showProvincePicker">
          <span class="company-chip" *ngIf="selectedProvince">
            <span class="company-chip-name">{{ selectedProvince.name }}</span>
            <ui-svg-icon class="chip-clear" svgIcon="close" size="small" (click)="clearProvince($event)"></ui-svg-icon>
          </span>
          <span class="company-placeholder" *ngIf="!selectedProvince && selectedCountry">
            {{ provinceSearchTerm || ('companies_selection_dialog.location_province' | translate) }}
          </span>
          <span class="company-placeholder" *ngIf="!selectedCountry">
            {{ 'companies_selection_dialog.select_country_first' | translate }}
          </span>
          <ui-svg-icon class="dropdown-caret" svgIcon="chevron_down" size="small"></ui-svg-icon>
        </div>

        <div class="company-panel" *ngIf="showProvincePicker">
          <div class="company-panel-search">
            <ui-form-field [ngModel]="provinceSearchTerm" (ngModelChange)="onProvinceSearch($event)"
              [placeholder]="'companies_selection_dialog.location_province' | translate"
              type="text" suffixIcon="search">
            </ui-form-field>
          </div>
          <div class="company-panel-list">
            <div class="loading-more" *ngIf="isLoadingProvinces">
              <ui-svg-icon svgIcon="eclipse"></ui-svg-icon>
            </div>
            <ng-container *ngIf="!isLoadingProvinces">
              <button type="button" class="company-option"
                *ngFor="let provinceOption of provinceOptions"
                [class.selected]="provinceOption.id === selectedProvince?.id"
                (click)="selectProvince(provinceOption)">
                <span>{{ provinceOption.name }}</span>
              </button>
              <div class="picker-no-data" *ngIf="provinceOptions.length === 0">
                {{ 'companies_selection_dialog.no_data' | translate }}
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="form-field">
    <label class="field-label muted">{{ 'companies_selection_dialog.location_street2' | translate }}</label>
    <ui-form-field [(ngModel)]="street2" type="text"
      [placeholder]="'companies_selection_dialog.location_street2' | translate">
    </ui-form-field>
  </div>

  <div class="erp-note" *ngIf="!hideErpNote">
    <ui-svg-icon svgIcon="info" size="small"></ui-svg-icon>
    <span>{{ 'companies_selection_dialog.erp_sync_note' | translate }}</span>
  </div>
</div>
